import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function topUpBalanceWithoutBinding(
  saveCardInfo: boolean,
  amount: number,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/top-up/balance-without-binding`,
      {
        amount: amount,
        currency: 2,
        saveCardInfo,
      },
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function topUpBalanceWithBinding(cardHolderId: string, amount: number) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/top-up/balance-with-binding`,
      {
        amount,
        currency: 2,
        cardHolderId,
      },
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function deactivateBinding(cardHolderId: string) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/deactivate-binding`,
      { cardHolderId },
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function payNow(orders: number[]) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/pay`,
      { orders: orders },
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  topUpBalanceWithBinding,
  topUpBalanceWithoutBinding,
  deactivateBinding,
  payNow,
};
